import styled from 'styled-components';
import { screen } from '@/helpers/screen';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

export const HeroWrapper = styled.header`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  min-height: 640px;

  text-align: center;

  background-color: #029f58;
  background-image: url(/${(props) => props.bg.small});
  background-position: top center;
  background-size: cover;

  position: relative;

  ${screen.md} {
    min-height: 340px;

    background-image: url(/${(props) => props.bg.medium});
  }

  ${screen.lg} {
    min-height: 440px;

    background-image: url(/${(props) => props.bg.large});
  }

  ${screen.xxlg} {
    min-height: 580px;

    background-image: url(/${(props) => props.bg.xxlarge});
  }
`;

export const Title = styled.h1`
  color: rgb(${getToken('color-text-inverted')});
  font-family: ${getToken('platform-font-title')};
  font-weight: ${getToken('font-weight-bold')};
  font-size: 32px;
  line-height: 40px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;

  margin-top: 40px;

  ${screen.md} {
    flex-direction: row;
    gap: 10px;
    margin-top: 92px;

    font-size: 34px;
    line-height: 40px;

    br {
      display: none;
    }
  }

  ${screen.lg} {
    margin-top: 100px;

    font-size: 48px;
    line-height: 54px;
  }

  ${screen.xxlg} {
    margin-top: 148px;

    font-size: 58px;
    line-height: 72px;
  }
`;

export const Subtitle = styled.p`
  color: rgb(${getToken('color-text-inverted')});
  font-family: ${getToken('platform-font-title')};
  font-weight: ${getToken('font-weight-bold')};
  font-size: 14px;
  line-height: 22px;

  margin-top: 8px;

  ${screen.md} {
    font-size: 16px;
    line-height: 24px;
  }

  ${screen.lg} {
    font-size: 21px;
    line-height: 34px;
  }

  ${screen.xxlg} {
    font-size: 26px;
    line-height: 38px;
  }
`;

export const TitleRotatorWrapper = styled.span`
  min-width: 100%;
  min-height: 50px;

  span {
    text-align: center;
  }

  ${screen.md} {
    justify-content: flex-start;
    min-width: 150px;
    min-height: auto;

    span {
      text-align: left;
    }
  }

  ${screen.lg} {
    min-width: 220px;
  }

  ${screen.xxlg} {
    min-width: 260px;
  }
`;
